export default "__VITE_ASSET__Dl9gG2X___"